<div class="modal-header">
  <h3 class="modal-title" id="modal-title">{{ 'SORTIMENT_DETAIL_EDITERA' | translate }}</h3>
  <button type="button" class="btn-close" aria-describedby="redigera sortiment" (click)="dismiss()"></button>
</div>
@if (isLoaded) {
  <div class="modal-body">
    <form id="sortimentForm" [formGroup]="editForm" (ngSubmit)="save()">
      <div class="row">
        <rask-input class="col-4 mt-0" label="{{ 'SORTIMENT_DETAIL_KOD' | translate }}" formControlName="kod"></rask-input>
        <rask-input class="col-4 mt-0 sortiment-namn" label="{{ 'SORTIMENT_DETAIL_NAMN' | translate }}" formControlName="namn"
          [append]="true" [readonly]="true">
          <div class="rask-input-append">
            <button class="btn btn-light append-button-height" (click)="getSortimentNamn()" type="button" id="button-get-namn">
              <i class="fas fa-sync"></i>
            </button>
          </div>
        </rask-input>
      </div>
      <div class="row">
        <rask-selector class="col-6" label="{{'SORTIMENT_DETAIL_PRODUKTGRUPP' | translate}}"
          formControlName="produktgruppId" [values]="produktgrupper"
          [viewFormatter]="ProduktgruppFormatter" [formatter]="ProduktgruppOutputFormatter">
        </rask-selector>
        <rask-checkbox class="col-2" text="{{'SORTIMENT_DETAIL_AKTIV' | translate}}" formControlName="aktiv">
        </rask-checkbox>
      </div>
    </form>
  </div>
}

<div class="modal-footer">
  <rask-save-button form="sortimentForm" click="save()" [disabled]="!canEdit()">
  </rask-save-button>
  <rask-button aid="buttonAvbryt" color="secondary" (click)="dismiss()" ngbAutofocus><span
  translate>{{ 'DEFAULT_BUTTON_LABEL_AVBRYT' | translate }}</span>
</rask-button>
</div>
